import { useState } from "react";
import VisualCsvJsonTool from "./tools/VisualCsvJsonTool";
import MarkdownEditorTool from "./tools/MarkdownEditorTool";
import SpriteSheetGeneratorTool from "./tools/SpriteSheetGeneratorTool";

const TOOL_OPTIONS = [
  {
    id: "visual-csv-json",
    title: "Visual CSV / JSON",
    icon: "🧩",
  },
  {
    id: "markdown-editor",
    title: "Markdown Editor",
    icon: "📝",
  },
  {
    id: "spritesheet-generator",
    title: "SpriteSheet Generator",
    icon: "🧱",
  },
];

function ToolsPage() {
  const [activeToolId, setActiveToolId] = useState("visual-csv-json");

  const activeTool = TOOL_OPTIONS.find((tool) => tool.id === activeToolId);

  return (
    <section className="admin-section-card tools-page">
      <div className="section-header tools-header">
        <div>
          <span className="section-eyebrow">Herramientas</span>
          <h2>Tools</h2>
          <p>
            Utilidades internas del proyecto. Puedes añadir más herramientas
            aquí después.
          </p>
        </div>
      </div>

      <div className="tools-top-selector">
        {TOOL_OPTIONS.map((tool) => (
          <button
            key={tool.id}
            type="button"
            className={
              activeToolId === tool.id
                ? "tools-tab tools-tab--active"
                : "tools-tab"
            }
            onClick={() => setActiveToolId(tool.id)}
          >
            <span>{tool.icon}</span>
            <strong>{tool.title}</strong>
          </button>
        ))}
      </div>

      <div className="tools-active-header">
        <span>{activeTool?.icon}</span>

        <div>
          <strong>{activeTool?.title}</strong>
          <small>Herramienta activa</small>
        </div>
      </div>

      {activeToolId === "visual-csv-json" && <VisualCsvJsonTool />}
      {activeToolId === "markdown-editor" && <MarkdownEditorTool />}
      {activeToolId === "spritesheet-generator" && <SpriteSheetGeneratorTool />}
    </section>
  );
}

export default ToolsPage;